import { createContext } from 'react';
var LocaleContext = createContext({
    locale: {},
});
export default LocaleContext;
